import {authorize} from "@athena-portal/components";
import * as React from "react";
import {UniqueSellingPointWidget} from "@ferry/plugin-ferry-journey/dist/widgets/annual/motor/UniqueSellingPointWidget";
import {Footer, resourcesHelper} from "@ferry/portal-core";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {BackButton} from "../../../../../components/navigation/BackButton";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";

@authorize
export class MigratedRenewalHelpPage extends React.Component {

    private pluginTemplates = new PluginTemplates();

    public async componentDidMount() {
        window.scrollTo(0, 0);
        this.pluginTemplates.setPageTitle("Help");
    }

    public render(): React.ReactNode {
        return (
            <>
                <FalconHeader/>
                <div className="help-page">
                    <BackButton isTop={true} link={`/dashboard/migratedRenewal`} />
                    <h1 className="help-title">Help</h1>
                    <p className="description-text">We like to make things easy and save everyone time. Our online team are here for you if you have a question or need some help.</p>
                    <h2 className="communication-title">Ways to get in touch</h2>
                    <ul>
                        <li className="underline"><a href={`mailto:${resourcesHelper.CONTACT_EMAIL.toLowerCase()}`}>Email us</a></li>
                        <li>If you prefer to speak to someone, please call us on: <span className="phone-number">{resourcesHelper.CONTACT_PHONE_NUMBER}</span></li>
                        <li className="no-bullet">Mon to Fri 8am - 8pm</li>
                        <li className="no-bullet">Sat and bank holidays 9am - 5pm</li>
                        <li className="no-bullet">Sun Closed</li>
                        <li className="no-bullet">For Text Phone first dial 18001</li>
                        <li className="no-bullet">Calls will be recorded</li>
                    </ul>
                    <UniqueSellingPointWidget brandName={resourcesHelper.THEME_NAME}/>
                    <p className="faq-description">We’ve answered your questions before you even thought of them! Head to our <span className="underline">
                            <a href={`${resourcesHelper.FAQ_URL.toLowerCase()}`} target="_blank">FAQs</a>
                        </span> section to save yourself time
                    </p>
                    <p className="faq-title">Most common questions</p>
                    <h3 className="faq-question">How do I manage my policy?</h3>
                    <div className="faq-answer">
                        <p>Simply sign into your account to manage your policy. Here's what you can do in your online account...</p>
                        <ul>
                            <li>add a new driver to your cover</li>
                            <li>change your car</li>
                            <li>add optional extras</li>
                            <li>cancel or renew your cover</li>
                            <li>manage your payments</li>
                            <li>see your policy documents</li>
                        </ul>
                    </div>
                    <h3 className="faq-question">Where can I find my policy documents?</h3>
                    <div className="faq-answer">
                        <p>You can access your policy documents <a href={"/dashboard/migratedRenewalDocuments"}>here</a></p>
                    </div>
                    <BackButton isTop={true} link={`/dashboard/migratedRenewal`} />
                </div>
                <Footer/>
            </>
        );
    }
}

